import { trustCards } from "views/components/pages/PharmacyAI/constants";
import { PageContainer } from "views/components/pages/PharmacyAI/layout";
import { TrustCard, TrustGrid, TrustSection } from "./styles";

const TrustCards = () => {
  return (
    <TrustSection>
      <PageContainer>
        <TrustGrid>
        {trustCards.map((card) => (
          <TrustCard key={card.heading}>
            <div
              className="icon-wrap"
              style={{ background: card.gradient }}
              aria-hidden
            >
              {card.emoji}
            </div>
            <h3>{card.heading}</h3>
            <p>{card.text}</p>
          </TrustCard>
        ))}
        </TrustGrid>
      </PageContainer>
    </TrustSection>
  );
};

export default TrustCards;
